/* global fbq */

import './App.css';
import LandingPage from './LandingPage';
import Dashboard from './Dashboard';
import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Button,Link, Popover,Drawer, TextField,Tooltip,Typography, AppBar, Toolbar, Divider, InputBase,Grid,Card, CardMedia, CardContent,  List, ListItem, ListItemText, Box  } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AmarilloRegular from './styles/DancingScript-VariableFont_wght.ttf';
import { motion } from "framer-motion";
import SearchIcon from '@material-ui/icons/Search';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import IconSwe from './static/svg/Flag_of_Sweden.png'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from "@mui/icons-material/Favorite";
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import { AnimatePresence } from 'framer-motion';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import ChatBox from './ChatBox';
import FavoritePosters from './FavoritePosters';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import clsx from 'clsx';
import Checkout from './components/Checkout';
import { Link as RouterLink } from "react-router-dom";
import { initializeAnalytics } from './analytics';
import ImageDropdown1 from "./images/dropdown_image.png"
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Autocomplete from '@mui/material/Autocomplete';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import { width } from '@mui/system';
import Cookies from 'js-cookie';
import { useNavigate, useLocation } from 'react-router-dom';
import CookieConsent from './CookieConsent';
import CookieSnackbar from './CookieSnackbar';

// animation settings
const floatVariant = {
  hidden: { y: 10 },
  visible: {
    y: -10,
    transition: {
      duration: 1,
      ease: 'easeInOut',
      repeat: Infinity,
      repeatType: 'reverse',
    },
  },
};


const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: 'New Font, sans-serif',
  },
  tooltip: {
    backgroundColor: 'white',
    color: 'black',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [AmarilloRegular],
      },
    },
  },
}));


function App() {
  const classes = useStyles();

  const [displayPage, setDisplayPage] = useState('landing');
  const [signedUrls, setSignedUrls] = useState();
  const isMobileView = useMediaQuery('(max-width:800px)');
  const isTabletView = useMediaQuery('(max-width:1200px)');
  const [menuOpen, setMenuOpen] = useState(false);
  const [openSidebar, setOpenSidebar] = useState(false);

  const [openOverlayLoad, setOpenOverlayLoad] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [openAIChat, setOpenAIChat] = useState(false);
  const iconVariants = {
    openMenu: { rotate: 0, opacity: 1 },
    closedMenu: { rotate: 180, opacity: 0 },
    openClose: { rotate: 360, opacity: 1 },
    closedClose: { rotate: 180, opacity: 0 },
  };

  const discountPercentage = 0.2

  const [existingWords, setExistingWords] = useState([
    "katt",
    "hund",
    "gorilla",
  ])
  const [cookieConsentGiven, setCookieConsentGiven] = useState(localStorage.getItem('cookieConsentGiven') === 'true');

  const [analyticsConsent, setAnalyticsConsent] = useState(
    localStorage.getItem('cookieAnalyticsConsent') ? localStorage.getItem('cookieAnalyticsConsent') === 'true' : true
  );


  const [isConsentDialogOpen, setIsConsentDialogOpen] = useState(false);
  const [openCookieBar, setOpenCookieBar] = useState(true);

  const scrollToPosition = (scrollPosition) => {
    window.scrollTo(0, scrollPosition);
  };


  const [openShoppingCart, setOpenShoppingCart] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleOpenPopover = (event) => {
    anchorRef.current = event.currentTarget;
    setIsOpen(true);
  };

  const handleClosePopover = () => {
    setIsOpen(false);
  };



  const [openBasketDrawer, setOpenBasketDrawer] = useState(false);

  const openDrawerBasket = () => {
    setOpenBasketDrawer(true);
  };

  const closeDrawerBassket = () => {
    setOpenBasketDrawer(false);
  };

  function calculateColumns(linksLength, maxRows) {
    if (linksLength <= 4) return 1;
    return Math.ceil(linksLength / maxRows);
  }


  const handleRemoveItem = (itemId, itemSize) => {
    setItemBasket((prevBasket) =>
      prevBasket.filter(
        (item) => item.id !== itemId || item.size !== itemSize
      )
    );
  };

  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  }
  async function fetchImageUrls() {
    const primaryEndpoint = 'https://backend-photo-gallery-hfzyyicqga-lz.a.run.app/signed-url';

    let data = null;

    try {
      const response = await axios.get(primaryEndpoint);
      console.log(response.status)
      data = response.data.signed_urls;
    } catch (primaryError) {
      console.error("Error with primary endpoint:", primaryError);
    }

    if (data) {
      shuffleArray(data);
      const aspectRatioOrder = ["2:3", "2:2", "3:2"];
      console.log(data)

      data.sort((a, b) => {
        return aspectRatioOrder.indexOf(a.aspectRatio) - aspectRatioOrder.indexOf(b.aspectRatio);
      });

      setSignedUrls(data);

      const existingWords = [...data.reduce((allTags, currentObject) => {
        const { tags } = currentObject;
        const lowerCaseTags = tags.map(tag => tag.toLowerCase());
        return new Set([...allTags, ...lowerCaseTags]);
      }, new Set())];

      setExistingWords(existingWords);
    }
  }
  useEffect(() => {
    fetchImageUrls();
  }, []);

const [backButtonClicked, setBackButtonClicked] = useState(false)

useEffect(() => {
  const handleBackButtonEvent = (e) => {
    console.log("scrollPosition", scrollPosition)
    e.preventDefault();
    console.log("Back button was clicked!");
    if(scrollPosition!==0){
      console.log("Start rescroll")
      setBackButtonClicked(true)
      scrollToPosition(scrollPosition)
    }
  };

  window.addEventListener("popstate", handleBackButtonEvent);

  return () => {
    window.removeEventListener("popstate", handleBackButtonEvent);
  };
}, []);

  const [openDropDownDivPoster, setOpenDropDownDivPoster] = useState("hidden")

  let closeTimer;

  const handleDropdownOpen = () => {
    if (closeTimer) clearTimeout(closeTimer);
    setOpenDropDownDivPoster("visible");
  };

  const handleDropdownClose = () => {
    closeTimer = setTimeout(() => {
      setOpenDropDownDivPoster("hidden");
    }, 400);
  };
  useEffect(() => {
    return () => {
      if (closeTimer) clearTimeout(closeTimer);
    };
  }, []);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [favoritePoster, setFavoritePoster] = useState(() => {
    const storedData = localStorage.getItem('favoritePoster');
    return storedData ? JSON.parse(storedData) : [];
  });

  const [openFavoritePopover, setOpenFavoritePopover] = useState(false)

  const handleClickFavorite = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseFavorite = () => {
    setAnchorEl(null);
  };
  const [open, setOpen] = React.useState(false);
  const [openBasket, setOpenBasket] = React.useState(false);

  const openFavorite = Boolean(anchorEl);
  const id = openFavorite ? 'simple-popover' : undefined;


  const togglePage = () => {
    setDisplayPage(displayPage === 'landing' ? 'dashboard' : 'landing');
  }
  const [displayStyle, setDisplayStyle] = useState("")
  const [openDrawer, setOpenDrawer] = useState(true)
  const [searchValue, setSearchValue] = useState('');
  const pageToDisplay = displayPage === 'landing' ? <LandingPage discountPercentage={discountPercentage} setCookieConsentGiven={setCookieConsentGiven} setOpenCookieBar={setOpenCookieBar} openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} togglePage={togglePage} setDisplayPage={setDisplayPage} setDisplayStyle={setDisplayStyle} /> : <Dashboard  searchValue={searchValue} discountPercentage={discountPercentage} setScrollPosition={setScrollPosition} scrollPosition={scrollPosition} setMenuOpen={setMenuOpen} openSidebar={openSidebar} openDrawerBasket={openDrawerBasket}  favoritePoster={favoritePoster} setFavoritePoster={setFavoritePoster} displayStyle={displayStyle} openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} signedUrls={signedUrls} togglePage={togglePage} openDrawer={openDrawer} setOpenDrawer={setOpenDrawer}/>;
  const [inputValue, setInputValue] = useState('');

  const [checkout, setCheckout] = useState(false);
  const [itemBasket, setItemBasket] = useState(() => {
    const storedData = localStorage.getItem('itemBasket');
    return storedData ? JSON.parse(storedData) : [];
  });

useEffect(() => {
    try {
      localStorage.setItem('favoritePoster', JSON.stringify(favoritePoster));
    } catch (e) {
      console.error("Failed to save favoritePoster to localStorage", e);
    }
}, [favoritePoster]);

useEffect(() => {
  if (itemBasket.length > 0) {
      localStorage.setItem('itemBasket', JSON.stringify(itemBasket));
  } else {
      localStorage.removeItem('itemBasket');
  }
}, [itemBasket]);


const [utmParams, setUtmParams] = useState({});

useEffect(() => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const utmSource = urlParams.get('utm_source');
  const utmMedium = urlParams.get('utm_medium');
  const utmCampaign = urlParams.get('utm_campaign');

  if (utmSource || utmMedium || utmCampaign) {
    setUtmParams({ utmSource, utmMedium, utmCampaign });
    console.log({ utmSource, utmMedium, utmCampaign })
  }

}, [window.location.search]);

useEffect(() => {
  try {
    const storedData = localStorage.getItem('favoritePoster');
    const retrievedArray = storedData ? JSON.parse(storedData) : [];
    setFavoritePoster(retrievedArray)
  } catch (e) {
    console.error("Failed to retrieve favoritePoster from localStorage", e);
  }
}, []);

useEffect(() => {
  if(analyticsConsent && analyticsConsent===true && cookieConsentGiven===true ){
    console.log("start: Analytics")
    initializeAnalytics();
  }else{
    console.log("stop: Analytics")
  }
}, [analyticsConsent]);



  const sections = [
    {
      title: 'POSTERS',
      links: [
        { name: 'Topplistan', route: '/topplista' },
        { name: 'Nyheter', route: '/nyheter' },
        { name: 'Rabatt', route: '/rabatt' },
      ],
    },
    {
      title: 'KATEGORIER',
      links: [
        { name: 'Djur', route: '/animals-1' },
        { name: 'Illustrationer', route: '/illustration' },
        { name: 'Abstrakt', route: '/abstract' },
        { name: 'Natur', route: '/nature-1' },
        { name: 'Fotokonst', route: '/photography' },
        { name: 'Framtid', route: '/futuristic' },
      ],
    },
    {
      title: 'MOTIV',
      links: [
        { name: 'Hund', route: '/search/hund' },
        { name: 'Katt', route: '/search/katt' },
        { name: 'Tiger', route: '/search/tiger' },
        { name: 'Groda', route: '/search/groda' },
        { name: 'Frukt', route: '/search/banan+jordgubbar+blåbär+vattenmelon+persika+citron+apelsin' },
        { name: 'Häst', route: '/search/häst' },
        { name: 'Capybara', route: '/search/capybara' },
        { name: 'Får', route: '/search/får' },
        { name: 'Kvinna', route: '/search/kvinna' },
        { name: 'Hamster', route: '/search/hamster' },
        { name: 'Björn', route: '/search/björn' },
      ],
    },
  ];


  const currentSections = sections;

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const handleBasketTooltipClose = () => {
    setOpenBasket(false);
  };

  const handleBasketTooltipOpen = () => {
    setOpenBasket(true);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  return (

    <div className="App" style={{ position: "relative" }}>
      <Router>
      <AppInner
        classes={classes}
        isMobileView={isMobileView}
        isTabletView={isTabletView}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        openSidebar={openSidebar}
        setOpenSidebar={setOpenSidebar}
        iconVariants={iconVariants}
        openAIChat={openAIChat}
        setOpenAIChat={setOpenAIChat}
        favoritePoster={favoritePoster}
        setFavoritePoster={setFavoritePoster}
        open={open}
        handleTooltipClose={handleTooltipClose}
        handleTooltipOpen={handleTooltipOpen}
        itemBasket={itemBasket}
        openDrawerBasket={openDrawerBasket}
        checkout={checkout}
        handleDropdownOpen={handleDropdownOpen}
        handleDropdownClose={handleDropdownClose}
        openDropDownDivPoster={openDropDownDivPoster}
        currentSections={currentSections}
        existingWords={existingWords}
        inputValue={inputValue}
        setInputValue={setInputValue}
        setSearchValue={setSearchValue}
        openBasketDrawer={openBasketDrawer}
        closeDrawerBassket={closeDrawerBassket}
        handleRemoveItem={handleRemoveItem}
        setCheckout={setCheckout}
        setOpenOverlayLoad={setOpenOverlayLoad}
        setOpenBasketDrawer={setOpenBasketDrawer}
        cookieConsentGiven={cookieConsentGiven}
        setCookieConsentGiven={setCookieConsentGiven}
        analyticsConsent={analyticsConsent}
        setAnalyticsConsent={setAnalyticsConsent}
        isConsentDialogOpen={isConsentDialogOpen}
        setIsConsentDialogOpen={setIsConsentDialogOpen}
        openCookieBar={openCookieBar}
        setOpenCookieBar={setOpenCookieBar}
        discountPercentage={discountPercentage}
        togglePage={togglePage}
        setDisplayPage={setDisplayPage}
        displayStyle={displayStyle}
        setDisplayStyle={setDisplayStyle}
        scrollPosition={scrollPosition}
        setScrollPosition={setScrollPosition}
        searchValue={searchValue}
        signedUrls={signedUrls}
        openDrawer={openDrawer}
        setOpenDrawer={setOpenDrawer}
        setItemBasket={setItemBasket}
      />
      </Router>
      <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={openOverlayLoad}
          onClick={null}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <motion.div
              variants={floatVariant}
              initial="hidden"
              animate="visible"
              style={{ marginBottom: '40px' }}
            >
              <MonetizationOnIcon style={{ fontSize: 90 }} />
            </motion.div>
            <CircularProgress color="inherit" />
          </Box>
        </Backdrop>

    </div>
  );
}

/** Inner component that has access to useLocation inside Router */
function AppInner(props) {
  const {
    classes, isMobileView, isTabletView, menuOpen, setMenuOpen, openSidebar, setOpenSidebar,
    iconVariants, openAIChat, setOpenAIChat, favoritePoster, setFavoritePoster,
    open, handleTooltipClose, handleTooltipOpen, itemBasket, openDrawerBasket,
    checkout, handleDropdownOpen, handleDropdownClose, openDropDownDivPoster, currentSections,
    existingWords, inputValue, setInputValue, setSearchValue, openBasketDrawer, closeDrawerBassket,
    handleRemoveItem, setCheckout, setOpenOverlayLoad, setOpenBasketDrawer,
    cookieConsentGiven, setCookieConsentGiven, analyticsConsent, setAnalyticsConsent,
    isConsentDialogOpen, setIsConsentDialogOpen, openCookieBar, setOpenCookieBar,
    discountPercentage, togglePage, setDisplayPage, displayStyle, setDisplayStyle,
    scrollPosition, setScrollPosition, searchValue, signedUrls, openDrawer, setOpenDrawer, setItemBasket,
  } = props;

  const location = useLocation();
  const navigate = useNavigate();
  const isLandingPage = location.pathname === '/';
  const [searchOpen, setSearchOpen] = useState(false);
  const searchInputRef = useRef(null);

  // Toggle search open/closed
  const handleSearchToggle = () => {
    setSearchOpen((prev) => {
      if (!prev) {
        setTimeout(() => searchInputRef.current?.focus(), 100);
      }
      return !prev;
    });
  };

  // Direct navigate on search submit (works from any page)
  const handleSearchSubmit = (value) => {
    const trimmed = (value || inputValue).trim();
    if (!trimmed) return;
    setSearchValue(trimmed);
    const searchValueForURL = trimmed.split(' ').join('+');
    navigate(`/search/${searchValueForURL}`);
    setSearchOpen(false);
    setInputValue('');
    if (window.gtag) {
      window.gtag('event', 'search_input', { input: trimmed });
      fbq('track', 'search_input', { input: trimmed });
    }
  };

  // Close search on Escape
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') setSearchOpen(false);
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, []);

  return (
      <Box>

    {/* ═══════════════════════════════════════════
        USP BAR - Slim top banner (hidden on shop pages)
        ═══════════════════════════════════════════ */}
    {isLandingPage && (
    <div className="fixed top-0 left-0 right-0 z-[1300] bg-brand-dark text-white text-center py-1.5 text-[11px] sm:text-xs tracking-wide">
      <span>Leverans 1-3 arbetsdagar</span>
      <span className="mx-2 opacity-40">|</span>
      <span>Fraktfritt över 349 kr</span>
      {!isMobileView && (
        <motion.img
          whileHover={{ scale: 1.16 }}
          whileTap={{ scale: 0.98 }}
          className="inline-block w-5 ml-3 align-middle"
          src={IconSwe}
          alt="Svenska"
        />
      )}
    </div>
    )}

    {/* ═══════════════════════════════════════════
        MAIN NAVBAR
        ═══════════════════════════════════════════ */}
    <nav className={`fixed left-0 right-0 z-[1299] bg-white shadow-md ${isLandingPage ? 'top-[28px]' : 'top-0'}`}>

      {/* ── Top row: Brand + action icons ── */}
      <div className="relative flex items-center justify-center px-3 sm:px-6 h-[56px]">

        {/* Left: Hamburger (mobile, shop pages only) */}
        <div className="absolute left-3 sm:left-6 flex items-center">
          {isMobileView && !isLandingPage && (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={() => {
                setMenuOpen(!menuOpen);
                setOpenSidebar(!openSidebar);
              }}
              style={{ padding: 6 }}
            >
              <AnimatePresence mode="wait">
                {!menuOpen ? (
                  <motion.div key="menu" initial="closedMenu" animate="openMenu" exit="closedMenu" variants={iconVariants}>
                    <MenuIcon style={{ fontSize: 22, color: '#161F25' }} />
                  </motion.div>
                ) : (
                  <motion.div key="close" initial="closedClose" animate="openClose" exit="closedClose" variants={iconVariants}>
                    <CloseIcon style={{ fontSize: 22, color: '#161F25' }} />
                  </motion.div>
                )}
              </AnimatePresence>
            </IconButton>
          )}
        </div>

        {/* Center: Brand name */}
        <RouterLink to="/" id="link" onClick={() => setDisplayPage("landing")} style={{ textDecoration: 'none' }}>
          <span style={{
            fontFamily: "'Dancing Script', cursive",
            fontWeight: 700,
            color: '#161825',
            fontSize: isMobileView ? '28px' : '36px',
            lineHeight: 1,
            userSelect: 'none',
          }}>
            PosterTopia
          </span>
        </RouterLink>

        {/* Right: Action icons */}
        <div style={{
          position: 'absolute', right: isMobileView ? 12 : 24,
          display: 'flex', alignItems: 'center', gap: '6px',
        }}>
          {/* ── Support icon ── */}
          {!isMobileView && (
            <>
              <button
                onClick={() => setOpenAIChat(!openAIChat)}
                className={`nav-action-btn${openAIChat ? ' active' : ''}`}
                title="Chatt & support"
              >
                <ChatBubbleOutlineRoundedIcon sx={{ fontSize: 19, color: '#161825' }} />
              </button>
              <div className="nav-action-separator" />
            </>
          )}

          {/* ── Favorites icon + dropdown ── */}
          <div style={{ position: 'relative' }}
            onMouseEnter={handleTooltipOpen}
            onMouseLeave={handleTooltipClose}
          >
            <button
              className={`nav-action-btn${open ? ' active' : ''}`}
              title="Favoriter"
            >
              {favoritePoster.length > 0 ?
                <FavoriteIcon sx={{ fontSize: 19, color: '#eb3477' }} /> :
                <FavoriteBorderIcon sx={{ fontSize: 19, color: '#161825' }} />
              }
              {favoritePoster.length > 0 && (
                <span className="nav-action-badge badge-heart">
                  {favoritePoster.length}
                </span>
              )}
            </button>

            {/* Favorites dropdown panel */}
            <AnimatePresence>
              {open && (
                <motion.div
                  initial={{ opacity: 0, y: -8, scale: 0.96 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{ opacity: 0, y: -8, scale: 0.96 }}
                  transition={{ duration: 0.2, ease: 'easeOut' }}
                  style={{
                    position: 'absolute', top: '48px', right: 0, zIndex: 1400,
                    width: '320px', maxHeight: '420px',
                    backgroundColor: '#fff', borderRadius: '16px',
                    boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
                    overflow: 'hidden',
                  }}
                >
                  {/* Header */}
                  <div style={{
                    padding: '16px 20px 12px', borderBottom: '1px solid #f0f0f0',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  }}>
                    <span style={{ fontSize: '14px', fontWeight: 700, color: '#161825' }}>
                      Favoriter
                    </span>
                    <span style={{ fontSize: '12px', color: '#888' }}>
                      {favoritePoster.length} {favoritePoster.length === 1 ? 'poster' : 'posters'}
                    </span>
                  </div>

                  {/* Content */}
                  <div style={{ overflowY: 'auto', maxHeight: '340px' }}>
                    {favoritePoster.length === 0 ? (
                      <div style={{
                        display: 'flex', flexDirection: 'column', alignItems: 'center',
                        justifyContent: 'center', padding: '40px 20px',
                      }}>
                        <FavoriteBorderIcon style={{ fontSize: 40, color: '#ddd', marginBottom: 12 }} />
                        <p style={{ fontSize: '14px', color: '#999', margin: 0 }}>
                          Du har inga favoriter än
                        </p>
                        <p style={{ fontSize: '12px', color: '#bbb', margin: '4px 0 0' }}>
                          Klicka på hjärtat på en poster för att spara den
                        </p>
                      </div>
                    ) : (
                      favoritePoster.map((poster) => (
                        <div
                          key={poster.imageId}
                          style={{
                            display: 'flex', alignItems: 'center', gap: '14px',
                            padding: '12px 20px', borderBottom: '1px solid #f8f8f8',
                            transition: 'background-color 0.1s', cursor: 'pointer',
                          }}
                          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#fafafa'}
                          onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                        >
                          {/* Thumbnail */}
                          <RouterLink to={"/" + poster.category + "/" + poster.category + "/" + poster.imageId}>
                            <img
                              src={poster.signedUrl}
                              alt={poster.title}
                              style={{
                                width: 52, height: 66, objectFit: 'cover',
                                borderRadius: '8px', flexShrink: 0,
                                border: '1px solid #eee',
                              }}
                            />
                          </RouterLink>

                          {/* Info */}
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <RouterLink
                              to={"/" + poster.category + "/" + poster.category + "/" + poster.imageId}
                              style={{ textDecoration: 'none' }}
                            >
                              <p style={{
                                margin: 0, fontSize: '13px', fontWeight: 600, color: '#222',
                                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                              }}>
                                {poster.title}
                              </p>
                            </RouterLink>
                            <p style={{ margin: '3px 0 0', fontSize: '12px', color: '#888' }}>
                              Från 149 kr
                            </p>
                          </div>

                          {/* Remove button */}
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setFavoritePoster(favoritePoster.filter(f => f.imageId !== poster.imageId));
                            }}
                            style={{
                              width: 30, height: 30, borderRadius: '8px', border: 'none',
                              backgroundColor: 'transparent', cursor: 'pointer', flexShrink: 0,
                              display: 'flex', alignItems: 'center', justifyContent: 'center',
                              transition: 'background-color 0.15s',
                            }}
                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#fee'}
                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                          >
                            <CloseIcon style={{ fontSize: 16, color: '#999' }} />
                          </button>
                        </div>
                      ))
                    )}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          {/* ── Shopping cart icon ── */}
          <div className="nav-action-separator" />
          <button
            onClick={openDrawerBasket}
            className="nav-action-btn"
            title="Varukorg"
          >
            <ShoppingBagOutlinedIcon sx={{ fontSize: 19, color: '#161825' }} />
            {Array.isArray(itemBasket) && itemBasket.length > 0 && (
              <span className="nav-action-badge badge-cart">
                {itemBasket.length}
              </span>
            )}
          </button>
        </div>
      </div>

      {/* ── Bottom row: Nav links (centered) + search icon ── */}
      {!checkout && (
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '0 16px', height: '42px', borderTop: '1px solid #f0f0f0',
          backgroundColor: '#fafafa', position: 'relative',
        }}>
          {/* Nav links - centered */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '0' }}>
            {!isMobileView && (
              <div
                onMouseEnter={handleDropdownOpen}
                onMouseLeave={handleDropdownClose}
              >
                <RouterLink to="/topplista" style={{ textDecoration: 'none' }}>
                  <button className="nav-poster-btn">
                    Posters ▾
                  </button>
                </RouterLink>
              </div>
            )}
            {[
              { label: 'Topplistan', to: '/topplista' },
              { label: 'Nyheter', to: '/nyheter' },
              ...(!isMobileView ? [{ label: 'Posterpaket', to: '/posterpaket' }] : []),
            ].map((item) => (
              <RouterLink key={item.to} to={item.to} style={{ textDecoration: 'none' }}>
                <button
                  className="cursor-pointer"
                  style={{
                    color: '#444', backgroundColor: 'transparent', border: 'none',
                    borderBottom: '2px solid transparent',
                    fontSize: '12px', fontWeight: 600, textTransform: 'uppercase',
                    letterSpacing: '0.1em', padding: '10px 16px',
                    transition: 'color 0.2s, border-color 0.2s',
                  }}
                  onMouseOver={(e) => { e.currentTarget.style.color = '#000'; e.currentTarget.style.borderBottomColor = '#161825'; }}
                  onMouseOut={(e) => { e.currentTarget.style.color = '#444'; e.currentTarget.style.borderBottomColor = 'transparent'; }}
                >
                  {item.label}
                </button>
              </RouterLink>
            ))}

            {/* Search toggle button */}
            <button
              onClick={handleSearchToggle}
              className="cursor-pointer"
              style={{
                background: 'transparent', border: 'none',
                padding: '8px 12px', display: 'flex', alignItems: 'center', gap: '6px',
                color: '#666', fontSize: '12px', fontWeight: 500,
                transition: 'color 0.2s',
                borderBottom: '2px solid transparent',
              }}
              onMouseOver={(e) => e.currentTarget.style.color = '#000'}
              onMouseOut={(e) => e.currentTarget.style.color = '#666'}
            >
              <SearchIcon style={{ fontSize: 18 }} />
              {!isMobileView && <span>Sök</span>}
            </button>
          </div>
        </div>
      )}
    </nav>

    {/* ═══════════════════════════════════════════
        SEARCH OVERLAY
        ═══════════════════════════════════════════ */}
    <AnimatePresence>
      {searchOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            onClick={() => setSearchOpen(false)}
            style={{
              position: 'fixed', inset: 0, zIndex: 1350,
              backgroundColor: 'rgba(0,0,0,0.3)', backdropFilter: 'blur(2px)',
            }}
          />
          {/* Search panel */}
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.25, ease: 'easeOut' }}
            style={{
              position: 'fixed', zIndex: 1351,
              top: isLandingPage ? '70px' : '42px',
              left: '50%', transform: 'translateX(-50%)',
              width: '94%', maxWidth: '580px',
              backgroundColor: '#fff', borderRadius: '16px',
              boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
              overflow: 'hidden',
            }}
          >
            {/* Search input area */}
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSearchSubmit();
              }}
              style={{
                display: 'flex', alignItems: 'center', padding: '4px 8px 4px 20px',
                borderBottom: '1px solid #eee',
              }}
            >
              <SearchIcon style={{ fontSize: 22, color: '#999', marginRight: 12, flexShrink: 0 }} />
              <input
                ref={searchInputRef}
                type="text"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                placeholder="Sök efter posters, motiv, kategorier..."
                autoFocus
                style={{
                  flex: 1, border: 'none', outline: 'none', fontSize: '16px',
                  padding: '16px 0', backgroundColor: 'transparent', color: '#222',
                  fontFamily: 'inherit',
                }}
              />
              {inputValue && (
                <IconButton
                  onClick={() => { setInputValue(''); searchInputRef.current?.focus(); }}
                  style={{ padding: 6, marginRight: 4 }}
                >
                  <CloseIcon style={{ fontSize: 18, color: '#999' }} />
                </IconButton>
              )}
              <button
                type="submit"
                disabled={!inputValue.trim()}
                style={{
                  backgroundColor: inputValue.trim() ? '#161825' : '#ccc',
                  color: '#fff', border: 'none', borderRadius: '10px',
                  padding: '8px 18px', fontSize: '13px', fontWeight: 600,
                  cursor: inputValue.trim() ? 'pointer' : 'default',
                  transition: 'background-color 0.2s', flexShrink: 0,
                }}
              >
                Sök
              </button>
            </form>

            {/* Autocomplete suggestions */}
            {inputValue.trim() && (
              <div style={{ maxHeight: '240px', overflowY: 'auto' }}>
                {existingWords
                  .filter((word) => word.toLowerCase().includes(inputValue.toLowerCase()))
                  .slice(0, 8)
                  .map((word, i) => (
                    <div
                      key={i}
                      onClick={() => handleSearchSubmit(word)}
                      style={{
                        display: 'flex', alignItems: 'center', gap: '12px',
                        padding: '10px 20px', cursor: 'pointer',
                        transition: 'background-color 0.1s',
                      }}
                      onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                      onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                      <SearchIcon style={{ fontSize: 16, color: '#bbb' }} />
                      <span style={{ fontSize: '14px', color: '#333' }}>
                        {word}
                      </span>
                    </div>
                  ))
                }
              </div>
            )}

            {/* Popular searches - shown when input is empty */}
            {!inputValue.trim() && (
              <div style={{ padding: '16px 20px 20px' }}>
                <p style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.1em', color: '#999', margin: '0 0 12px 0' }}>
                  Populära sökningar
                </p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {['Katt', 'Hund', 'Natur', 'Abstrakt', 'Tiger', 'Häst', 'Capybara', 'Frukt'].map((term) => (
                    <button
                      key={term}
                      onClick={() => handleSearchSubmit(term.toLowerCase())}
                      style={{
                        backgroundColor: '#f3f3f3', border: '1px solid #e8e8e8',
                        borderRadius: '20px', padding: '6px 14px',
                        fontSize: '13px', color: '#444', cursor: 'pointer',
                        transition: 'all 0.15s',
                      }}
                      onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#161825'; e.currentTarget.style.color = '#fff'; e.currentTarget.style.borderColor = '#161825'; }}
                      onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#f3f3f3'; e.currentTarget.style.color = '#444'; e.currentTarget.style.borderColor = '#e8e8e8'; }}
                    >
                      {term}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </motion.div>
        </>
      )}
    </AnimatePresence>

    {/* ═══════════════════════════════════════════
        MEGA DROPDOWN - centered under navbar
        ═══════════════════════════════════════════ */}
    <div
      onClick={isMobileView ? handleDropdownClose : null}
      onMouseEnter={!isMobileView ? handleDropdownOpen : handleDropdownOpen}
      onMouseLeave={!isMobileView ? handleDropdownClose : null}
      style={{
        position: 'fixed',
        zIndex: 1298,
        left: '50%',
        transform: openDropDownDivPoster === 'visible'
          ? 'translateX(-50%) translateY(0)'
          : 'translateX(-50%) translateY(-10px)',
        visibility: openDropDownDivPoster,
        opacity: openDropDownDivPoster === 'visible' ? 1 : 0,
        top: isLandingPage ? '124px' : '96px',
        width: '92%',
        maxWidth: '720px',
        backgroundColor: '#fff',
        borderRadius: '0 0 16px 16px',
        boxShadow: '0 12px 40px rgba(0,0,0,0.10), 0 2px 8px rgba(0,0,0,0.06)',
        transition: 'opacity 0.2s ease, transform 0.2s ease, visibility 0.2s',
        overflow: 'hidden',
      }}
    >
      {/* Top accent line */}
      <div style={{ height: '3px', background: 'linear-gradient(90deg, #161825, #fe8627)' }} />

      <div style={{
        padding: '28px 32px 32px',
        display: 'grid',
        gridTemplateColumns: '1fr 1.5fr 2fr',
        gap: '32px',
      }}>
        {currentSections.map((section, index) => (
          <div key={index}>
            <h4 style={{
              fontSize: '10px', fontWeight: 700, color: '#999', textTransform: 'uppercase',
              letterSpacing: '0.15em', margin: '0 0 12px 10px',
            }}>
              {section.title}
            </h4>
            <ul style={{
              listStyle: 'none', padding: 0, margin: 0,
              ...(index === 2 ? { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0' } : {}),
            }}>
              {section.links.map((link, linkIndex) => (
                <li key={linkIndex}>
                  <RouterLink
                    to={link.route}
                    onClick={handleDropdownClose}
                    className="dropdown-link"
                  >
                    {link.name}
                  </RouterLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>

    {/* ═══════════════════════════════════════════
        CART DRAWER
        ═══════════════════════════════════════════ */}
    <Drawer anchor="right" open={openBasketDrawer} onClose={closeDrawerBassket}>
      <div style={{ width: isMobileView ? '85vw' : '400px', height: '100vh' }}>
        <Checkout
          onRemoveItem={handleRemoveItem}
          itemBasket={itemBasket}
          setCheckout={setCheckout}
          setOpenOverlayLoad={setOpenOverlayLoad}
          setOpenBasketDrawer={setOpenBasketDrawer}
        />
      </div>
    </Drawer>

    {/* ═══════════════════════════════════════════
        COOKIE CONSENT
        ═══════════════════════════════════════════ */}
    <CookieConsent
      cookieConsentGiven={cookieConsentGiven}
      setCookieConsentGiven={setCookieConsentGiven}
      analyticsConsent={analyticsConsent}
      setAnalyticsConsent={setAnalyticsConsent}
      isConsentDialogOpen={isConsentDialogOpen}
      setIsConsentDialogOpen={setIsConsentDialogOpen}
    />
    <CookieSnackbar
      setOpenCookieBar={setOpenCookieBar}
      openCookieBar={openCookieBar}
      analyticsConsent={analyticsConsent}
      cookieConsentGiven={cookieConsentGiven}
      setAnalyticsConsent={setAnalyticsConsent}
      setCookieConsentGiven={setCookieConsentGiven}
      setIsConsentDialogOpen={setIsConsentDialogOpen}
    />

    {/* ═══════════════════════════════════════════
        AI CHAT
        ═══════════════════════════════════════════ */}
    <div style={{ visibility: openAIChat ? 'visible' : 'hidden' }}>
      <ChatBox setOpenChat={setOpenAIChat} isMobileView={isMobileView} />
    </div>

          <Routes>
            <Route path="/" element={<LandingPage discountPercentage={discountPercentage} setCookieConsentGiven={setCookieConsentGiven} setOpenCookieBar={setOpenCookieBar} openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} togglePage={togglePage} setDisplayPage={setDisplayPage} setDisplayStyle={setDisplayStyle} />} />
            <Route path="/search/:searchTerms/*" element={<Dashboard discountPercentage={discountPercentage} setScrollPosition={setScrollPosition} scrollPosition={scrollPosition} setCookieConsentGiven={setCookieConsentGiven} setOpenCookieBar={setOpenCookieBar} setMenuOpen={setMenuOpen} menuOpen={menuOpen} openDrawerBasket={openDrawerBasket}  itemBasket={itemBasket} setItemBasket={setItemBasket} setCheckout={setCheckout} checkout={checkout} searchValue={searchValue} setSearchValue={setSearchValue} favoritePoster={favoritePoster} setFavoritePoster={setFavoritePoster} displayStyle={displayStyle} openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} signedUrls={signedUrls} togglePage={togglePage} openDrawer={openDrawer} setOpenDrawer={setOpenDrawer}/>} />
            <Route path="/:style/:category?/:imageId?/*" element={<Dashboard discountPercentage={discountPercentage} setScrollPosition={setScrollPosition} scrollPosition={scrollPosition} setCookieConsentGiven={setCookieConsentGiven} setOpenCookieBar={setOpenCookieBar} setMenuOpen={setMenuOpen} menuOpen={menuOpen} openDrawerBasket={openDrawerBasket}  itemBasket={itemBasket} setItemBasket={setItemBasket} setCheckout={setCheckout} checkout={checkout} searchValue={searchValue} setSearchValue={setSearchValue} favoritePoster={favoritePoster} setFavoritePoster={setFavoritePoster} displayStyle={displayStyle} openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} signedUrls={signedUrls} togglePage={togglePage} openDrawer={openDrawer} setOpenDrawer={setOpenDrawer}/>} />
          </Routes>
      </Box>
  );
}



export default App;
